<template>
  <div class="checkbox-icon" @click="toggleCheck">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      :height="iconSize"
      :width="iconSize"
      :fill="fill"
      v-if="isChecked"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      />
    </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      :height="iconSize"
      :width="iconSize"
      :fill="fill"
      v-else
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
    </svg>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<{}, Methods, {}, Props>({
  props: {
    isChecked: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: Number,
      default: 24,
    },
    fill: {
      type: String,
      default: "#d0d0d0",
    },
    emitEvent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleCheck() {
      if (this.emitEvent) {
        this.$emit("change", !this.isChecked);
      }
    },
  },
});

interface Props {
  isChecked: boolean;
  iconSize: number;
  fill: string;
  emitEvent: boolean;
}

interface Methods {
  toggleCheck(): void;
}
</script>

<style lang="scss" scoped>
.checkbox-icon {
  display: flex;
  align-items: center;
}
</style>
